import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[boelsQa]',
  standalone: true,
})
export class QaHooksDirective {
  private qaValue: string;

  @Input({ alias: 'boelsQa' })
  public set qa(value: string) {
    this.qaValue = value;
  }

  @HostBinding('attr.data-qa') public get dataAttribute(): string {
    return this.qaValue;
  }
}
